import React, { Component } from 'react';
import '@styles/adm/shared/filterPagination.scss'; 

export class FilterPagination extends Component {
    static displayName = FilterPagination.name;

    constructor(props) {
        super(props);
    }

    RenderPaginationText = () => {

        let pagination = this.props.paginationCount == 'all' ? this.props.listCount : this.props.paginationCount;
        let paginationStart = (this.props.page - 1) * pagination;
        return <div className=''>
            <div>
                {`Záznam ${paginationStart} - ${paginationStart + this.props.listCount} z celkových ${this.props.allRowsCount}`}
            </div>
            <div>
                Počet záznamů: {(paginationStart + this.props.listCount) - paginationStart}
            </div>
        </div>
    }

    RenderPaginationPageNumbers = () => {

        let numberOfVisiblePages = 10;

        let pagination = this.props.paginationCount == 'all' ? this.props.listCount : this.props.paginationCount;
        let numberOfPages = Math.ceil(this.props.allRowsCount / pagination);
        if (numberOfPages <= 0)
            numberOfPages = 1;

        let pageNumbers = [];
        for (let i = 1; i <= numberOfPages; i++) {

            if (i > numberOfVisiblePages && i < numberOfPages - numberOfVisiblePages) {
                if (pageNumbers[pageNumbers.length - 1] != '...')
                    pageNumbers.push('...');

                continue;
            }

            pageNumbers.push(i);
        }

        return (
            <div className='d-flex align-items-center flex-wrap'>
                {pageNumbers.map((pn) => {

                    if (pn == '...')
                        return <div key={pn} className='fw-bold'>{pn}</div>

                    return (
                        <div role='button' key={pn} className={`pageNumber ${this.props.page == pn ? 'current fw-bold' : ''}`} onClick={() => this.props.OnPageNumberClick(pn)}>
                            {pn}
                        </div>
                    );
                })}
            </div>
        );
    }

    RenderPages = () => {
        return <div className='pb-2 d-flex align-items-start'>
            <span className='me-1'>Stránka:</span>
            {this.RenderPaginationPageNumbers()}
        </div>
    }

    render() {
        return (
            <div id='filterPagination' className='d-flex flex-column'>
                {this.RenderPaginationText()}
                {this.RenderPages()}
            </div>
        );
    }
}
